import { ApiClient } from '../../Shared/interfaces/ApiClient';
import { tabLinks, TabKeys } from '../components/InventoryView/InventoryViewConstants';
import {
  InventorySlotPackage,
  InventoryApiResponse,
} from '../interfaces/InventoryDashboardInterfaces';
import {
  getGatewayData,
  getStarPackageData,
  getMThankyouData,
  getWPClass1Data,
  getILMClass1Data,
  getMContextualClass1CpmData,
  getDContextualClass1CpmData,
  getPPPClass1Data,
  getWD2TargetedClass1Data,
  getROSDSPUnguaranteedData,
} from '../services/service';
import { EndpointQueryKeys } from '../constants/endpoints';

const {
  GET_GATEWAY_DATA,
  GET_STAR_PACKAGE,
  GET_MTHANKYOU,
  GET_WP_CLASS1,
  GET_ILM_CLASS1,
  GET_MCONTEXTUAL_CLASS1_CPM,
  GET_DCONTEXTUAL_CLASS1_CPM,
  GET_PPP_CLASS1,
  GET_WD2_TARGETED_CLASS1,
  GET_ROS_DSP_UNGUARANTEED,
} = EndpointQueryKeys;

interface TableConfig {
  optionalSuperTHeaders?: string[];
  totalColumns: string[];
  getTotalColumns?: (data: InventoryApiResponse) => string[];
}

interface QueryConfig {
  queryKey: string;
  queryFn: (
    api: ApiClient,
    artEventId: string | null | undefined
  ) => Promise<InventoryApiResponse | null>;
  dataType: InventoryApiResponse;
}

// Keyed by TabKeys (not positional) so a tab always resolves its own query — see InventoryView,
// which looks this up by the active tab's key. Avoids silent mismatches between parallel lists.
export const queryConfigs: Record<TabKeys, QueryConfig> = {
  [TabKeys.GATEWAY]: { queryKey: GET_GATEWAY_DATA, queryFn: getGatewayData, dataType: {} as InventoryApiResponse },
  [TabKeys.STAR_PACKAGE]: { queryKey: GET_STAR_PACKAGE, queryFn: getStarPackageData, dataType: {} as InventoryApiResponse },
  [TabKeys.MTHANKYOU]: { queryKey: GET_MTHANKYOU, queryFn: getMThankyouData, dataType: {} as InventoryApiResponse },
  [TabKeys.WP_CLASS_1]: { queryKey: GET_WP_CLASS1, queryFn: getWPClass1Data, dataType: {} as InventoryApiResponse },
  [TabKeys.ILM_CLASS_1]: { queryKey: GET_ILM_CLASS1, queryFn: getILMClass1Data, dataType: {} as InventoryApiResponse },
  [TabKeys.MCONTEXTUAL_CLASS_1_CPM]: { queryKey: GET_MCONTEXTUAL_CLASS1_CPM, queryFn: getMContextualClass1CpmData, dataType: {} as InventoryApiResponse },
  [TabKeys.DCONTEXTUAL_CLASS_1_CPM]: { queryKey: GET_DCONTEXTUAL_CLASS1_CPM, queryFn: getDContextualClass1CpmData, dataType: {} as InventoryApiResponse },
  [TabKeys.PPP_CLASS_1]: { queryKey: GET_PPP_CLASS1, queryFn: getPPPClass1Data, dataType: {} as InventoryApiResponse },
  [TabKeys.WD2_TARGETED_CLASS_1]: { queryKey: GET_WD2_TARGETED_CLASS1, queryFn: getWD2TargetedClass1Data, dataType: {} as InventoryApiResponse },
  [TabKeys.ROS_DSP_UNGUARANTEED]: { queryKey: GET_ROS_DSP_UNGUARANTEED, queryFn: getROSDSPUnguaranteedData, dataType: {} as InventoryApiResponse },
};

export const getTotalColumnsForTab = (
  data: InventoryApiResponse
): string[] => {
  if (!data?.slotPackages) return [];

  return data.slotPackages.flatMap((pkg: InventorySlotPackage) => [
    `${pkg.slotPackageName}_totalImpression`,
    `${pkg.slotPackageName}_overallValue`,
  ]);
};

export const tableConfigs: Record<string, TableConfig> = Object.fromEntries(
  tabLinks.map((tab) => [
    tab.label,
    { totalColumns: [], getTotalColumns: getTotalColumnsForTab },
  ])
);
